<button (click)="pressed()" [ngClass]="{ 'button-active': active }">
  <img
    [src]="'assets/img/widgets/' + widget.key + '.svg'"
    [alt]="widget.column"
  />
  <p>{{ count }}</p>
</button>
